import { ecLean, record, upper, type Row } from './context';
import { readItemField } from '../compile/item-field-reader';
import { readPlayerCharacterField } from '../display/player-character-field';

/** ONE WHO/WHY text for the hover card and the cast-refusal toast: the name, the id when the surface has no creature to hang it on
 *  (the toast), and the row's refusal with the `unported:encounter-member:member:<uuid>:` prefix stripped, so no UUID repeats. */
export function participantCompileRefusalReason(memberName: string, rowRefusal: string | null, memberId = ''): string {
    const why = rowRefusal?.replace(/^unported:encounter-member:member:[0-9a-f-]+:/i, '');
    return `reaction-compile-incomplete: ${memberName}${memberId ? ` (${memberId})` : ''}${why ? ` (${why})` : ''}`;
}

/** Diagnostic projection of held rows only; absence never certifies a participant. */
export function participantCompileRefusal(encounter: Row, member: Row | null, id: string) {
    const memberName = String(readPlayerCharacterField(member, 'player_name')
        || ecLean(member ?? {}, 'encounter_creature_name') || ecLean(member ?? {}, 'creature_name')
        || readItemField(member, 'item_name') || 'Unnamed creature');
    const refusals = Array.isArray(encounter._compile_row_refusals) ? encounter._compile_row_refusals : [];
    const held = refusals.map(record).find(row => upper(row?.entity_id) === upper(id));
    const rowRefusal = typeof member?._entity_refusal === 'string' ? member._entity_refusal
        : typeof held?.reason === 'string' ? held.reason : null;
    return { targetId: id, memberName, rowRefusal,
        reason: !member && !held ? 'reaction-compile-incomplete'
            : participantCompileRefusalReason(memberName, rowRefusal) };
}
